<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-5 is-offset-1">
                    <br>
                    <br>
                    <h3 class="is-size-1 has-text-primary section-title">Explore a Strategic Partnership</h3>
                    <br>
                    <p class="">WebBank is a leading player in the digital lending space, driving innovation in financial products through embedded finance with Strategic Partner platforms. We engage in a full range of banking activities including consumer and commercial loan products, revolving lines of credit, credit cards, private-label card issuance, auto refinancing, and more.</p>
                    <br>
                </div>
                <div class="column is-5">
                    <br>
                    <img src="https://assets.webbank.com/R5_C1723.png" class="body-image" alt="Strategic Partnerships at WebBank" />
                </div>
            </div>

            <hr>
            <br>
            <br>

    <section class="section" v-if="success">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2 has-text-centered">
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <span class="icon has-text-success"><i class="fa-solid fa-badge-check fa-10x"></i></span>
                    <br>
                    <br>
                    <br>
                    <br>
                    <p class="has-text-success is-size-3">Thank you! Your message has been sent!</p>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </section>

            <div class="columns" v-else>
                <div class="column is-8 is-offset-2">
                    <div class="has-text-centered">
                    <h3 class="is-size-1 has-text-primary section-title">Let's Work Together</h3>
                    <br>
                    <p>Interested in learning more about a Strategic Partnership with WebBank? Complete the form and someone from our team will reach out to you to start a conversation. </p>
                    </div>
                    <br>
                    <br>

            <div class="notification is-danger" v-if="this.errors.length">
                Please check your input and try again.
            </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">First Name</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('first_name')}"
                                        type="text"
                                        name="first_name"
                                        placeholder="John"
                                        v-model="form.first_name">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('first_name')">Please enter your first name.</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Last Name</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('last_name')}"
                                        type="text"
                                        name="last_name"
                                        placeholder="Doe"
                                        v-model="form.last_name">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('last_name')">Please enter your last name.</p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Email</label>
                                <div class="control has-icons-left has-icons-right">
                                    <input class="input"
                                        type="email"
                                        name="email"
                                        :class="{'is-danger': this.errors.includes('email')}"
                                        placeholder="me@mycompany.com"
                                        v-model="form.email">
                                    <span class="icon is-small is-left">
                                        <i class="fas fa-envelope"></i>
                                    </span>
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('email')">Please enter your email.</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Phone</label>
                                <div class="control">
                                    <input class="input"
                                        type="tel"
                                        v-maska:[options]
                                        :class="{'is-danger': this.errors.includes('phone')}"
                                        name="phone"
                                        placeholder="xxx-xxx-xxxx"
                                        v-model="form.phone"/>
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('phone')">Please enter your phone number.</p>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Company Name</label>
                                <div class="control">
                                    <input class="input"
                                        type="text"
                                        name="company_name"
                                        placeholder="My Company"
                                        v-model="form.company_name">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('company_name')">Please enter your company name.</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Website</label>
                                <div class="control">
                                    <input class="input"
                                        type="text"
                                        name="website"
                                        placeholder="htps://mycomapany.com"
                                        v-model="form.website">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('website')">Please enter your website.</p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Number of Employees</label>
                                <div class="control">
                                    <input class="input"
                                        type="number"
                                        name="number_employees"
                                        placeholder="1"
                                        v-model="form.number_employees">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('number_employees')">Please enter your number of employees.</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Years in Business</label>
                                <div class="control">
                                    <input class="input"
                                        type="number"
                                        name="years_in_business"
                                        placeholder="1"
                                        v-model="form.years_in_business">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('years_in_business')">Please enter your years in business.</p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Annual Revenue</label>
                                <div class="control has-icons-left has-icons-right">
                                    <input class="input"
                                        type="tel"
                                        name="annual_revenue"
                                        placeholder="xxxxxx"
                                        v-model="form.annual_revenue">
                                    <span class="icon is-small is-left">
                                        <i class="fas fa-dollar-sign"></i>
                                    </span>
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('annual_revenue')">Please enter your annual revenue.</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Projected Year-One Product Volume</label>
                                <div class="control">
                                    <input class="input"
                                        type="number"
                                        name="year_one_volume"
                                        placeholder="1"
                                        v-model="form.year_one_volume">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('year_one_volume')">Please enter your product volume.</p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Amount of Most Recent Capital Raise</label>
                                <div class="control has-icons-left has-icons-right">
                                    <input class="input"
                                        type="tel"
                                        name="recent_capital_amount"
                                        placeholder="xxxxxx"
                                        v-model="form.recent_capital_amount">
                                    <span class="icon is-small is-left">
                                        <i class="fas fa-dollar-sign"></i>
                                    </span>
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('recent_capital_amount')">Please enter the amount of your capital raise..</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Date of Most Recent Capital Raise</label>
                                <div class="control has-icons-left has-icons-right">
                                    <input class="input"
                                        type="date"
                                        name="recent_capital_date"
                                        placeholder="mm/dd/yyyy"
                                        v-model="form.recent_capital_date">
                                    <span class="icon is-small is-left">
                                        <i class="fas fa-calendar"></i>
                                    </span>
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('recent_capital_date')">Please enter your capital raise date.</p>
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Product Stage</label>
                        <div class="control">
                            <div class="select">
                            <select v-model="form.product_stage" name="product_stage">
                                <option>Choose One...</option>
                                <option value="in_market">In Market</option>
                                <option value="in_testing">In Testing</option>
                                <option value="under_development">Under Development</option>
                            </select>
                            </div>
                        </div>
                        <p class="help has-text-danger" v-if="this.errors.includes('product_stage')">Please choose your product stage.</p>
                    </div>
                    <br>


                <div class="field">
                    <label class="label">Description of Opportunity</label>
                    <div class="control">
                        <textarea class="textarea"
                            placeholder="Your message..."
                            name="description"
                            v-model="form.description"></textarea>
                    </div>
                    <p class="help has-text-danger" v-if="this.errors.includes('description')">Please enter a message.</p>
                </div>

                <div class="field is-grouped">
                <div class="control">
                    <button class="button is-primary" @click="submitForm" :class="{'is-loading': sending}">Submit</button>
                </div>
            </div>

                </div>
            </div>
        </div>
    </section>

</template>

<script>
import axios from 'axios';
import { vMaska } from "maska"
export default {
    directives: { maska: vMaska },
    created() {
        document.title = "Partner With Us - WebBank";
    },

    data: function () {
        return {
            form: {
                form_name: 'become_partner',
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                company_name: null,
                description: null,
                recent_capital_amount: null,
                recent_capital_date: null,
                annual_revenue: null,
                year_one_volume: null,
                product_stage: null,
                website: null,
                years_in_business: null,
                number_employees: null,
            },
            sending: false,
            success: false,
            errors: [],
            options: {
                mask: "###-###-####",
                eager: false
            }
        }
    },

    methods: {
        submitForm: function () {
            this.errors = [];
            this.sending = true;
            console.log('submitting form...');

            for (let x in this.form) {
                console.log('checking form field: ' + x);
                console.log('value: ' + this.form[x]);
                if (!this.form[x]) {
                    console.log('field has an error! - ' + x);
                    this.errors.push(x);
                }
            }
            if (this.errors.length) {
                console.log('failing with validation errors: ', this.errors);
                this.sending = false;
                return false;
            }

            let data = {"body": this.form};
            console.log('posting data: ' + JSON.stringify(data));
            axios.post(process.env.VUE_APP_MAIL_ENDPOINT, data)
                .then(result => {
                    console.log('result: ' + JSON.stringify(result));
                    this.success = true;
                }).finally(() => this.sending = false);
        },

        checkPhone: function () {
            console.log('phone: ' + this.form.phone)
        }
    }
}
</script>
